export const SPLASH = "accueil";
export const HOME = 'test-des-modules';
export const HOME_RESSOURCES = 'table-des-ressources';
export const DASHBOARD = 'dashboard';
export const ESPACE = 'espace-pedagogique';
export const COMING_SOON = 'fonctionnalites-des-modules';
export const LOGOUT = 'logout';
export const GALLERY = 'galerie';
export const GAME = 'activite';
export const EAN13 = '3133097389943';